export default __webpack_public_path__ + "static/media/luxe-offer.2c1d13cf.svg";